import type { FC } from 'react';
import { useMemo } from 'react';
// components
import TextCarouselLoader from '@/components/TextCarouselLoader';

const WaitingScreen: FC = () => {
	const pharses = useMemo(() => {
		return [
			'inbound24',
			'manageAppointments',
			'listenPortal',
			'revenueFact',
			'howRevenue'
		];
	}, []);

	return (
		<div className="h-72 md:h-full">
			<div className="animate-fadeIn h-full">
				<div className="inset-0 bg-white h-full">
					<TextCarouselLoader
						className="text-lg"
						phrases={pharses}
					/>
				</div>
			</div>
		</div>
	);
};

export default WaitingScreen;
